export default __webpack_public_path__ + "static/sub-logo-kr-a44f2b14ccb9068ba58df88898c916e5.png";